import React from 'react';
import { ThemeProvider } from './contexts/ThemeContext';
import VideocorsoFormativo from './components/VideocorsoFormativo';

function App() {
  return (
    <ThemeProvider>
      <VideocorsoFormativo />
    </ThemeProvider>
  );
}

export default App;